/*
  DPS: voorwaarden-vinkje in de winkelwagen (snippets/dps-cart-terms.liquid).
  <dps-cart-terms> blokkeert de checkout-submit en verbergt de express-knoppen zolang het vinkje
  uit staat, en schrijft het akkoord als cart-attribuut 'Voorwaarden akkoord' via /cart/update.js,
  zodat het ook op de order staat als de klant via Shop Pay, PayPal of Google Pay afrekent (die
  knoppen gaan buiten het cart-formulier om). Hyper her-rendert de cart-footer via de Section
  Rendering API (cart.js, onCartUpdate: innerHTML van #MainCart-… en #CartDrawerFooter-…); het
  element verbindt dan opnieuw en zet de stand van deze pagina terug uit het geheugen. Een nieuwe
  pagina begint altijd uitgevinkt.
*/
(function () {
  if (customElements.get('dps-cart-terms')) return;

  const ATTRIBUTE = 'Voorwaarden akkoord';
  let acceptedOnThisPage = false;

  class DpsCartTerms extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.error = this.querySelector('[data-terms-error]');
      if (!this.checkbox) return;

      this.form = this.checkbox.form;

      // JS neemt de validatie over, zodat de eigen melding verschijnt in plaats van de browser-ballon.
      this.checkbox.required = false;
      this.checkbox.setAttribute('aria-required', 'true');
      this.checkbox.checked = acceptedOnThisPage;

      this.onChange = () => {
        acceptedOnThisPage = this.checkbox.checked;
        this.saveAttribute(this.checkbox.checked);
        this.sync();
      };

      this.onSubmit = (event) => {
        if (this.checkbox.checked) return;
        // Alleen afrekenen tegenhouden. Zonder event.submitter (oude Safari/Firefox) wordt elke submit
        // van dit formulier geblokkeerd; dat is nu gelijk, want het formulier heeft alleen een checkout-knop.
        if (event.submitter && event.submitter.name !== 'checkout') return;
        event.preventDefault();
        // Enter in een aantal-veld geeft een impliciete submit met de checkout-knop als default button:
        // wél tegenhouden, maar geen melding en geen focus-sprong midden in het typen.
        const active = document.activeElement;
        const implicit = active && active.tagName === 'INPUT' && active !== this.checkbox;
        if (!implicit) this.showError();
      };

      this.checkbox.addEventListener('change', this.onChange);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      this.sync();
    }

    disconnectedCallback() {
      if (this.checkbox && this.onChange) this.checkbox.removeEventListener('change', this.onChange);
      if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit);
    }

    get expressButtons() {
      const scope = this.closest('.cart__footer--buttons, [id^="CartDrawerFooter"]') || document;
      return scope.querySelectorAll('.additional-checkout-buttons');
    }

    saveAttribute(accepted) {
      const routes = window.FoxTheme && window.FoxTheme.routes;
      const url = (routes && routes.cart_update_url) || '/cart/update.js';
      const attributes = {};
      attributes[ATTRIBUTE] = accepted ? 'ja' : '';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      }).catch(() => {
        /* mislukt stil; het formulier stuurt het attribuut alsnog mee bij de gewone checkout */
      });
    }

    sync() {
      const accepted = this.checkbox.checked;
      this.expressButtons.forEach((el) => el.toggleAttribute('hidden', !accepted));
      if (accepted) this.hideError();
    }

    showError() {
      if (this.error) this.error.hidden = false;
      this.checkbox.setAttribute('aria-invalid', 'true');
      this.checkbox.focus();
    }

    hideError() {
      if (this.error) this.error.hidden = true;
      this.checkbox.removeAttribute('aria-invalid');
    }
  }

  customElements.define('dps-cart-terms', DpsCartTerms);
})();
